/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Aborted_ToastInputs */

const en_subtitle_export_aborted_toast = /** @type {(inputs: Subtitle_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitle export was aborted`)
};

const fr_subtitle_export_aborted_toast = /** @type {(inputs: Subtitle_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'exportation des sous-titres a été interrompue.`)
};

const de_subtitle_export_aborted_toast = /** @type {(inputs: Subtitle_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Export der Untertitel wurde abgebrochen.`)
};

const it_subtitle_export_aborted_toast = /** @type {(inputs: Subtitle_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'esportazione dei sottotitoli è stata interrotta`)
};

const ru_subtitle_export_aborted_toast = /** @type {(inputs: Subtitle_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт субтитров был прерван.`)
};

const es_subtitle_export_aborted_toast = /** @type {(inputs: Subtitle_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se canceló la exportación de subtítulos`)
};

const zh_cn2_subtitle_export_aborted_toast = /** @type {(inputs: Subtitle_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕导出已中止`)
};

const ja_subtitle_export_aborted_toast = /** @type {(inputs: Subtitle_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕のエクスポートが中止されました`)
};

const hi_subtitle_export_aborted_toast = /** @type {(inputs: Subtitle_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक निर्यात रद्द कर दिया गया`)
};

const pt_pt2_subtitle_export_aborted_toast = /** @type {(inputs: Subtitle_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A exportação de legendas foi cancelada.`)
};

/**
* | output |
* | --- |
* | "Subtitle export was aborted" |
*
* @param {Subtitle_Export_Aborted_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_aborted_toast = /** @type {((inputs?: Subtitle_Export_Aborted_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Aborted_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_aborted_toast(inputs)
	if (locale === "de") return de_subtitle_export_aborted_toast(inputs)
	if (locale === "it") return it_subtitle_export_aborted_toast(inputs)
	if (locale === "ru") return ru_subtitle_export_aborted_toast(inputs)
	if (locale === "es") return es_subtitle_export_aborted_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_aborted_toast(inputs)
	if (locale === "ja") return ja_subtitle_export_aborted_toast(inputs)
	if (locale === "hi") return hi_subtitle_export_aborted_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_aborted_toast(inputs)
	return en_subtitle_export_aborted_toast(inputs)
});